// The Files block's one rule about links, in a module of its own so the
// harness can run it in node.
//
// A block stores whatever the editor sent, so a link is only drawn when
// it is OUR download route for the item's own uuid — /files/{uuid} or
// /files/{uuid}/{name} on http(s). Anything else (a typed URL, a
// javascript: one) answers null and the item draws as plain text.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function safeFileUrl(item) {
    const uuid = String(item?.uuid || '');
    if (!UUID.test(uuid)) return null;
    let u;
    try {
        u = new URL(String(item?.url || ''));
    } catch {
        return null;
    }
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return null;
    if (u.username || u.password) return null;
    const parts = u.pathname.split('/').filter(Boolean);
    if (parts[0] !== 'files' || parts[1] !== uuid || parts.length > 3) return null;
    return u.href;
}

// The parts of a library row a Files block keeps.
export function fileItemFrom(upload) {
    return {
        uuid: upload.uuid,
        title: upload.title,
        description: '',
        extension: upload.extension,
        kind: upload.kind,
        size_bytes: upload.size_bytes,
        url: upload.url,
    };
}
